<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      @if (creationMode) {
        {{ "MATERIAL_COMBO_PANEL.TITLE_CREATE" | translate }}
      } @else {
        {{ "MATERIAL_COMBO_PANEL.TITLE" | translate }} — {{ material?.name }}
      }
    </div>
    <div class="panel-header-actions flex-row-center-center">
      <div
        class="gt2-light-green flex-row-center-center"
        style="width: 60px; height: 56px"
      >
        <button
          type="button"
          matTooltip="{{ 'MATERIAL_COMBO_PANEL.CREATE_MATERIAL' | translate }}"
          mat-icon-button
          (click)="onCreateMaterial()"
        >
          <mat-icon class="icon-mat-black">add</mat-icon>
        </button>
      </div>
      <button
        mat-icon-button
        type="button"
        class="panel-close-btn"
        (click)="close()"
        aria-label="Close panel"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </header>

  <div class="panel-body" (keyup.enter)="!saving ? saveData() : null">
    <ngx-spinner
      bdColor="rgba(51,51,51,0.6)"
      name="materialComboSpinner"
      size="medium"
      color="white"
      [fullScreen]="false"
      type="ball-scale-multiple"
    ></ngx-spinner>

    <div class="flex-column">
      <mat-form-field floatLabel="auto" class="mr-4 fxFlexAuto">
        <mat-label>{{
          "MATERIAL_COMBO_PANEL.SEARCH" | translate | ucfirst
        }}</mat-label>
        <input
          #filter
          id="search"
          [(ngModel)]="filterValue"
          matInput
          [maxLength]="200"
        />
        <mat-icon
          *ngIf="filterValue"
          matSuffix
          mat-icon
          (click)="loadMaterialList()"
          >search</mat-icon
        >
        <mat-icon *ngIf="filterValue" matSuffix mat-icon (click)="clearSearch()"
          >close</mat-icon
        >
      </mat-form-field>

      <!-- Filtres : catégorie de matériel + tags. Un filtre actif suffit à
           lancer la recherche, même sans mot-clé. -->
      <div class="material-filters-row flex-row-start-center">
        <p-dropdown
          [options]="materialCategories"
          [(ngModel)]="selectedCategoryUuid"
          (onChange)="onMaterialFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          [filter]="true"
          placeholder="{{ 'MATERIAL_COMBO_PANEL.CATEGORY_FILTER' | translate }}"
          [style]="{ minWidth: '220px' }"
        ></p-dropdown>
        <p-multiSelect
          *ngIf="availableTags.length > 0"
          [options]="availableTags"
          [(ngModel)]="selectedTagUuids"
          (onChange)="onMaterialFilterChange()"
          optionLabel="name"
          optionValue="uuid"
          [showClear]="true"
          placeholder="{{ 'MATERIAL_COMBO_PANEL.TAGS_FILTER' | translate }}"
          selectedItemsLabel="{0} tags"
          [style]="{ minWidth: '180px' }"
        >
          <ng-template let-tag pTemplate="item">
            <div class="flex-row-start-center" style="gap: 8px">
              <span class="tag-color-dot" [ngClass]="tag.color"></span>
              {{ tag.name }}
            </div>
          </ng-template>
        </p-multiSelect>
      </div>

      @if (!isSmallScreen) {
        <div class="flex-row fxLayout-column-xs" style="margin-bottom: 16px">
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "MATERIAL_COMBO_PANEL.LEFT_LIST_LABEL" | translate }}
            </div>
          </div>
          <div class="flex-column fxFlex-100p">
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "MATERIAL_COMBO_PANEL.RIGHT_LIST_LABEL" | translate }}
            </div>
          </div>
        </div>
      }

      <div cdkDropListGroup class="flex-row fxLayout-column-xs">
        <!-- ---------------------------------------------------- gauche -->
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "MATERIAL_COMBO_PANEL.LEFT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #materialList
            cdkDropList
            [cdkDropListData]="materials"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom mr-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
          >
            <div
              *ngIf="isLoading"
              class="flex-column-center-center fxFlex-100p"
            >
              <mat-spinner [diameter]="28"></mat-spinner>
            </div>

            <div
              *ngIf="showSearchMaterialHint"
              class="flex-column-center-center fxFlex-100p combo-list-empty-message"
            >
              {{ "MATERIAL_COMBO_PANEL.SEARCH_MATERIAL" | translate }}
            </div>

            <div
              *ngIf="showNoSearchResults"
              class="flex-column-center-center fxFlex-100p combo-list-empty-message"
            >
              <div>
                {{ "MATERIAL_COMBO_PANEL.NO_SEARCH_RESULTS" | translate }}
              </div>
              <div>
                {{
                  "MATERIAL_COMBO_PANEL.NO_SEARCH_RESULTS_TRY_AGAIN" | translate
                }}
              </div>
            </div>

            @for (item of materials; track item.uuid) {
              <div
                *ngIf="!isLoading"
                matRipple
                [cdkDragData]="item"
                cdkDrag
                [cdkDragDisabled]="mobileLayout.isMobileLayout()"
                cdkDragHandle
              >
                <div class="product-child-item flex-row-space-between-center">
                  <div class="flex-row-start-center fxFlex-85p">
                    <mat-icon
                      *ngIf="!mobileLayout.isMobileLayout()"
                      class="mr-8"
                      >drag_handle</mat-icon
                    >
                    <div
                      style="min-width: 200px"
                      class="flex-column-start-start"
                    >
                      <div class="item-name-internal">
                        {{ item.name_internal }}
                      </div>
                      <div class="item-name">
                        {{ item.name }} | {{ item.price_label }}
                      </div>
                    </div>
                  </div>
                  <div class="flex-row-end-center fxFlex-15p">
                    <mat-icon
                      mat-icon
                      class="ml-8 icon-mat-dark"
                      (click)="onAddFromCatalogue(item)"
                      >add</mat-icon
                    >
                    <mat-icon
                      *ngIf="!isSmallScreen"
                      mat-icon
                      class="ml-8 mr-8 icon-mat-dark"
                      matTooltip="{{ 'GENERIC.OPEN_NEW_TAB' | translate }}"
                      (click)="onOpenInNewTab(item)"
                      >{{ getIcon("NEW_TAB") }}</mat-icon
                    >
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- ---------------------------------------------------- droite -->
        <div [ngClass]="isSmallScreen ? '' : 'fxFlex-50p'">
          @if (isSmallScreen) {
            <div class="pb-4 mat-caption flex-row-center-start">
              {{ "MATERIAL_COMBO_PANEL.RIGHT_LIST_LABEL" | translate }}
            </div>
          }
          <div
            #comboList
            cdkDropList
            [cdkDropListData]="combo"
            (cdkDropListDropped)="onDrop($event)"
            [ngClass]="
              isSmallScreen
                ? 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list-xs'
                : 'ngx-dnd-container-custom ml-4 ngx-dnd-scrollable combo-list flex-column content-list'
            "
          >
            @for (item of combo; track item.uuid; let i = $index) {
              <div
                matRipple
                [cdkDragData]="item"
                cdkDrag
                [cdkDragDisabled]="
                  mobileLayout.isMobileLayout() || childProcess
                "
              >
                <div
                  class="product-child-item-right flex-row-space-between-center"
                >
                  <div class="flex-row-start-center combo-row-main">
                    <mat-icon
                      *ngIf="!mobileLayout.isMobileLayout()"
                      cdkDragHandle
                      class="mr-8 qty-drag-handle"
                      >drag_handle</mat-icon
                    >
                    <mat-form-field class="form-input-container qty-input">
                      <input
                        matInput
                        class="text-center"
                        type="text"
                        pattern="^[+-]?[0-9]+([.,][0-9]{1,2})?"
                        [ngModel]="item.qty"
                        (ngModelChange)="onItemQtyChange($event, item)"
                        style="text-align: center"
                      />
                    </mat-form-field>
                    <div
                      matTooltip="{{ item.name }} | {{ item.price_label }}"
                      [matTooltipPosition]="'right'"
                      class="ml-16 combo-row-name"
                    >
                      <div class="item-name-internal">
                        {{ item.name_internal || item.name }}
                      </div>
                      <div class="combo-row-flags flex-row-start-center">
                        <mat-checkbox
                          [ngModel]="item.internal_view_only"
                          (ngModelChange)="onInternalViewChange($event, item)"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="childProcess"
                          matTooltip="{{
                            'MATERIAL_COMBO_PANEL.INTERNAL_VIEW_ONLY'
                              | translate
                          }}"
                          class="combo-flag"
                        >
                          {{
                            "MATERIAL_COMBO_PANEL.INTERNAL_VIEW_ONLY_SHORT"
                              | translate
                          }}
                        </mat-checkbox>
                        <mat-checkbox
                          [ngModel]="item.show_unit_price"
                          (ngModelChange)="onShowUnitPriceChange($event, item)"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="childProcess"
                          matTooltip="{{
                            'MATERIAL_COMBO_PANEL.SHOW_UNIT_PRICE' | translate
                          }}"
                          class="combo-flag"
                        >
                          {{
                            "MATERIAL_COMBO_PANEL.SHOW_UNIT_PRICE_SHORT"
                              | translate
                          }}
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>

                  <div class="flex-row-end-center combo-row-actions">
                    <mat-icon (click)="onAddItem(item)" class="ml-8"
                      >add</mat-icon
                    >
                    <mat-icon (click)="onLessItem(item)" class="ml-8"
                      >remove</mat-icon
                    >
                    <mat-icon
                      (click)="onRemoveItem(item)"
                      class="ml-8"
                      matTooltip="{{
                        'MATERIAL_COMBO_PANEL.REMOVE_ITEM' | translate
                      }}"
                      >{{ getIcon("DELETE") }}</mat-icon
                    >
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div
          [ngClass]="
            isSmallScreen ? 'flex-row fxFlex-100p' : 'flex-row fxFlex-50p'
          "
        >
          &nbsp;
        </div>
        <div
          [ngClass]="
            isSmallScreen
              ? 'flex-row-end-start fxFlex-100p'
              : 'flex-row-end-start fxFlex-50p'
          "
        >
          <div *ngIf="combo && combo.length > 0" class="pr-4">
            {{ combo.length }}
            {{ combo && combo.length > 1 ? "items" : "item" }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <footer class="panel-footer flex-row-center-center">
    <button
      mat-raised-button
      (click)="saveData()"
      [class.btn-spinner]="saving"
      [disabled]="saving || childProcess"
      class="accent mr-16"
    >
      {{ "GENERIC.SAVE" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="close()">
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
